// covered-by: frontends/carrie/src/ask-v2/__tests__/paths.test.ts
/**
 * V2 URL shapes. Same prefixes as V1 Ask Puntt so in-place app.puntt.ai
 * links keep working. Do not import src/routes/ask-puntt.
 */

export const ASK_V2_HOME_PATH = "/" as const;
export const ASK_V2_ASK_HOME_PATH = "/ask-puntt" as const;
export const ASK_V2_CHATS_PATH = "/ask-puntt/chats" as const;
export const ASK_V2_CHAT_PATH = "/ask-puntt/$chatId" as const;
export const ASK_V2_PROJECTS_PATH = "/ask-puntt/projects" as const;
export const ASK_V2_PROJECT_PATH = "/ask-puntt/projects/$projectId" as const;

export function askV2ChatPath(chatId: string): string {
  return `/ask-puntt/${chatId}`;
}

export function askV2ProjectPath(projectId: string): string {
  return `/ask-puntt/projects/${projectId}`;
}
